import { HARBOR_FACTS } from '@/lib/harbor-facts';

const nunito = {
  fontFamily:
    "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
};

type AtAGlanceProps = {
  className?: string;
};

export function AtAGlance({ className = '' }: AtAGlanceProps) {
  return (
    <section className={`bg-white py-14 ${className}`.trim()}>
      <div className='mx-auto max-w-5xl px-6'>
        <h2 className='text-2xl font-bold text-gray-900 md:text-3xl' style={{ ...nunito, fontWeight: 700 }}>
          At a glance
        </h2>
        <p className='mt-4 max-w-3xl text-lg leading-relaxed text-gray-700' style={nunito}>
          {HARBOR_FACTS.quote}
        </p>
        <dl className='mt-8 grid gap-4 sm:grid-cols-2'>
          {HARBOR_FACTS.atAGlance.map((item) => (
            <div key={item.label} className='rounded-xl border border-gray-200 bg-gray-50 p-5'>
              <dt className='text-sm font-semibold uppercase tracking-wide text-gray-500' style={nunito}>
                {item.label}
              </dt>
              <dd className='mt-2 text-base text-gray-900' style={nunito}>
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
        <p className='mt-6 text-sm leading-relaxed text-gray-600' style={nunito}>
          {HARBOR_FACTS.whenNotToRecommend}
        </p>
      </div>
    </section>
  );
}
